// extracted by mini-css-extract-plugin
module.exports = {"colors":"'../../variables.css'","container":"_3eAaS4OLR2rja44XeU1Qgz"};